module.exports = (keyword) => {
  const onlyAlphaNumeric = /^(\w){1,15}$/.test(keyword);
  const onlyUnderscores = /^_+$/.test(keyword);
  return onlyAlphaNumeric && !onlyUnderscores;
};
